import { Divider } from "@affinity/components/Divider";
import { Section } from "@affinity/components/Section";
import { getQuantityDescription } from "@affinity/constants/FormatHelpers";
import PlaceOrderPaymentStart from "@affinity/Handlers/PlaceOrderPaymentStart";
import { CustomState } from "@affinity/Store/Reducers";
import { AffinityProduct } from "@affinity/Store/StoreTypes";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    const selectedProduct = state.affinity_place_order.selectedProduct;
    const qtyOrdered = state.affinity_place_order.quantity;
    let productId: string | undefined;
    switch (selectedProduct) {
        case AffinityProduct.Regular:
            productId = state.affinity_place_order.productRegular?.id;
            break;
        case AffinityProduct.Premium:
            productId = state.affinity_place_order.productPremium?.id;
            break;
    }
    const cartId = state.data.carts.currentId;

    return {
        // Map required state elements to component properties
        formatedQuantity: getQuantityDescription(state.affinity_place_order.quantity || 0),
        productId,
        qtyOrdered,
        state,
        cartId,
    };
};

const mapDispatchToProps = {
    // Map loader and setter methods to component properties
    PlaceOrderPaymentStart,
};

type Step6ConfirmationProps = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const Step6ConfirmationState: React.FC<Step6ConfirmationProps> = ({
    formatedQuantity,
    productId,
    qtyOrdered,
    PlaceOrderPaymentStart,
    state,
    cartId,
}) => {
    const [confirm, setConfirm] = React.useState(false);
    const history = useHistory();

    const redirectToCheckout = () => {
        history.push("/CheckoutReviewAndSubmit");
    }
    
    const addToCartClickHandler = async () => {
        if (productId && qtyOrdered && confirm) {

            const result = await PlaceOrderPaymentStart({ 
                customState: state, 
                cartId, 
                onComplete: () => redirectToCheckout()
            });

        }
    };

    return (
        <Section shouldFocus={true}>
            <Checkbox onChange={e => setConfirm(val => !val)} checked={confirm}>
                {translate("I confirm I have the capacity for delivery of ")}{formatedQuantity}
            </Checkbox>
            <Divider />
            <Button
                type="submit"
                variant="primary"
                sizeVariant="large"
                icon={{ position: "right", src: "ChevronRight" }}
                css={css`
                    align-self: end;
                `}
                onClick={addToCartClickHandler}
                disabled={!confirm}
            >
                {translate("Continue")}
            </Button>
        </Section>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Step6ConfirmationState);